(() => {
  if (window.RavinPdpEditorialScrollLoaded) return;
  window.RavinPdpEditorialScrollLoaded=true;

  const selector='[data-ravin-pdp-editorial]';
  const instances=new WeakMap();
  const desktop=window.matchMedia('(min-width:990px)');
  const clamp=(n,low,high)=>Math.max(low,Math.min(high,n));

  function init(root) {
    if (!root || instances.has(root)) return;
    const gallery=root.querySelector('[data-ravin-pdp-arc-gallery]');
    const cards=gallery ? Array.from(gallery.querySelectorAll('[data-ravin-pdp-arc-card]')) : [];
    const controller=new AbortController();
    const copyPanel=root.querySelector('.rpa-pdp-left');
    const copyInner=root.querySelector('.rpa-pdp-left-inner');
    const copyToggle=root.querySelector('[data-rpa-copy-toggle]');
    const copyText=root.querySelector('[data-rpa-copy-text]');
    const isArabic=(document.documentElement.lang||'').toLowerCase().startsWith('ar');
    const expandLabel=isArabic?'عرض المزيد':'Read more';
    const collapseLabel=isArabic?'عرض أقل':'Show less';
    let sizeObserver=null;

    function measureCopy(){
      if(!copyPanel||!copyInner||!copyToggle) return;
      if(!desktop.matches){
        copyPanel.classList.remove('has-overflow','is-expanded');
        copyToggle.hidden=true;
        copyToggle.setAttribute('aria-expanded','false');
        if(copyText) copyText.textContent=expandLabel;
        return;
      }
      const overflowed=copyPanel.classList.contains('is-expanded') ||
        copyInner.scrollHeight > copyInner.clientHeight+6;
      copyPanel.classList.toggle('has-overflow',overflowed);
      copyToggle.hidden=!overflowed;
    }

    if(copyToggle){
      copyToggle.addEventListener('click',()=>{
        const expanded=copyPanel.classList.toggle('is-expanded');
        copyToggle.setAttribute('aria-expanded',String(expanded));
        if(copyText) copyText.textContent=expanded?collapseLabel:expandLabel;
        if(!expanded) copyInner.scrollTop=0;
        window.requestAnimationFrame(measureCopy);
      },{signal:controller.signal});
    }

    function measureGallery(){
      if(gallery && desktop.matches){
        const height=Math.round(gallery.getBoundingClientRect().height);
        if(height>0)root.style.setProperty('--rpa-actual-media-height',height+'px');
      }else{
        root.style.removeProperty('--rpa-actual-media-height');
      }
      window.requestAnimationFrame(measureCopy);
    }

    if(gallery && typeof ResizeObserver==='function'){
      sizeObserver=new ResizeObserver(measureGallery);
      sizeObserver.observe(gallery);
    }
    let scheduled=0;
    let lastIndex=null;
    let lastY=window.scrollY;
    let activated=false;

    function render() {
      scheduled=0;
      if (!desktop.matches || !activated || !gallery || cards.length<2 ||
          !root.isConnected || typeof gallery.ravinGoTo!=='function') return;

      const rect=root.getBoundingClientRect();
      const distance=Math.max(1,root.offsetHeight-window.innerHeight);
      const fraction=clamp(-rect.top/distance,0,1);
      const index=Math.round(fraction*(cards.length-1));
      if (index===lastIndex) return;
      lastIndex=index;
      gallery.ravinGoTo(index,false);
    }

    function schedule() {
      if (!scheduled) scheduled=window.requestAnimationFrame(render);
    }

    function onScroll() {
      const y=window.scrollY;
      if (Math.abs(y-lastY)<1) return;
      lastY=y;
      if (!desktop.matches) return;
      activated=true;
      schedule();
    }

    function resize() {
      measureGallery();
      if (desktop.matches && activated) schedule();
    }

    window.addEventListener('scroll',onScroll,{passive:true,signal:controller.signal});
    window.addEventListener('resize',resize,{passive:true,signal:controller.signal});
    window.addEventListener('pageshow',resize,{signal:controller.signal});
    desktop.addEventListener?.('change',resize,{signal:controller.signal});

    root.addEventListener('ravin:variantChanged',()=>{
      lastIndex=null;
    },{signal:controller.signal});

    instances.set(root,()=>{
      controller.abort();
      if(sizeObserver)sizeObserver.disconnect();
      if (scheduled) window.cancelAnimationFrame(scheduled);
      instances.delete(root);
    });
    window.requestAnimationFrame(measureGallery);
  }

  function initAll(scope) {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll?.(selector).forEach(init);
  }
  function unloadAll(scope) {
    const nodes=[];
    if (scope.matches?.(selector)) nodes.push(scope);
    scope.querySelectorAll?.(selector).forEach(node=>nodes.push(node));
    nodes.forEach(node=>instances.get(node)?.());
  }

  if (document.readyState==='loading') {
    document.addEventListener('DOMContentLoaded',()=>initAll(document),{once:true});
  } else initAll(document);

  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  document.addEventListener('shopify:section:unload',event=>unloadAll(event.target));
})();